import { createAuthClient } from 'better-auth/client';
import { genericOAuthClient } from 'better-auth/client/plugins';

export const authClient = createAuthClient({
  // Required for build and crawler environments where `window` is not defined. In runtime, this will be overridden with the actual origin.
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  baseURL: globalThis.window === undefined ? 'http://localhost:3000' : globalThis.window.location.origin,
  plugins: [genericOAuthClient()],
});

export const { signIn, signOut, useSession } = authClient;
